export default {
  cashOut: 'CASH_OUT',
  confirm: 'CONFIRM',
  rejected: 'REJECTED'
};
